<template>
  <BrandContainer
    v-show="shouldShow"
    :brandColour="brandColour"
    data-test="base-upsell"
  >
    <div class="w-full flex flex-col p-8">
      <div
        v-if="dismissible"
        @click="dismiss"
        class="closeButton"
        aria-hidden="true"
      >
        <IconButton
          icon="times"
          variant="invisible"
          data-test="dismiss-button"
        />
      </div>
      <div
        :class="{ 'md:grid-cols-2': !$slots.media, 'md:grid-cols-3': !!$slots.media }"
        class="flex flex-col md:grid gap-4 p-4"
        >
        <div class="md:col-span-2">
          <div
            :class="{ 'md:flex': inlineIcon }"
          >
            <slot name="icon" />
            <div
              :class="{ 'lg:ml-5 md:ml-5': inlineIcon }"
              class="w-full flex flex-col"
            >
              <slot name="title" />
              <slot name="explainer" />
              <slot
                v-if="inlineIcon"
                name="cta"
              />
            </div>
          </div>
        </div>
        <div
          v-if="!!$slots.media"
          class="md:col-span-3 md:row-span-3 lg:col-span-1 self-center pl-0 lg:pl-base pb-base lg:pb-0"
        >
          <slot name="media" />
        </div>
        <div class="md:col-span-2">
          <slot
            v-if="!inlineIcon"
            name="cta"
          />
        </div>
      </div>
    </div>
  </BrandContainer>
</template>

<script>
import { BrandContainer } from '@/components/library/containers/BrandContainer';
import IconButton from '@/components/library/buttons/IconButton.vue';

export default {
  name: 'BaseUpsell',
  components: {
    BrandContainer,
    IconButton,
  },
  data() {
    return {
      shouldShow: true,
    };
  },
  props: {
    dismissible: {
      type: Boolean,
      default: true,
    },
    brandColour: {
      type: String,
      default: 'purple',
    },
    inlineIcon: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    dismiss() {
      this.$emit('dismissed');
      this.shouldShow = false;
    },
  },
};
</script>

<style scoped>
.closeButton {
  @apply absolute top-0 right-0;
}
.closeButton .l-BaseButton.variant-invisible {
  @apply p-base;
  @apply hover:text-black;
  @apply focus-visible:text-black;
  @apply active:text-black;
}
</style>
